import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(town)/components/FAQToggle.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/car-min.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
